import { render } from "./apInputMask.vue?vue&type=template&id=bc97dea0&scoped=true&ts=true"
import script from "./apInputMask.vue?vue&type=script&lang=ts"
export * from "./apInputMask.vue?vue&type=script&lang=ts"

import "./apInputMask.vue?vue&type=style&index=0&id=bc97dea0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc97dea0"]])

export default __exports__